const isFactsheetHavingFactsAssignedToRooms = facts => {
  return Object.values(facts ?? []).some(
    factInstances => factInstances.some(instance => instance.appliesTo?.length > 0)
  )
}

const isRoomHavingBothExpediaAndBookingCodes = room => {
  return room.details?.some(detail =>
    detail.codes?.some(code => code.id === 'booking') &&
    detail.codes?.some(code => code.id === 'expedia')
  )
}
const isAllRoomsHaveAtLeastOneImage = (images, rooms) => {
  if (rooms.length === 0) {
    return false
  }
  const roomImagesMap = new Set(
    images.flatMap(image => image.rooms)
  )
  return rooms.every(room => roomImagesMap.has(room.id))
}

export {
  isFactsheetHavingFactsAssignedToRooms,
  isRoomHavingBothExpediaAndBookingCodes,
  isAllRoomsHaveAtLeastOneImage,
}
